"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var react_1 = __importStar(require("react"));
var capitalizeFirst = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var getHeading = function (color) {
    switch (color) {
        case 'danger':
            return 'An error occurred';
        default:
            return capitalizeFirst(color || 'Title');
    }
};
var Alert = function (props) {
    var _a = (0, react_1.useState)(true), visible = _a[0], setVisible = _a[1];
    var onDismiss = function () {
        setVisible(false);
    };
    if (!props.messages || props.messages.length == 0)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(react_1.default.Fragment, null, visible && (react_1.default.createElement("div", { className: "alert alert-".concat(props.color || 'danger', " ").concat(props.dismiss ? 'alert-dismissible' : '', " fade show"), role: "alert" },
        !props.noHeading && (react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col" },
                react_1.default.createElement("h4", { className: "alert-heading" }, props.title || getHeading(props.color || 'danger'))))),
        props.messages.map(function (m, i) {
            return (react_1.default.createElement(react_1.default.Fragment, { key: i },
                i !== 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement("div", { className: "col" },
                            react_1.default.createElement("hr", null))))),
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col" },
                        react_1.default.createElement("p", { className: "mb-0" }, m)))));
        }),
        props.dismiss && (react_1.default.createElement("button", { type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: function () {
                onDismiss();
            } },
            react_1.default.createElement("span", { "aria-hidden": "true" }, "\u00D7")))))));
};
exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map